// React Imports
import { ReactElement, useEffect, useState } from "react";

// Third Party Libraries Imports
import { useLocation } from "react-router-dom";

// Local Imports
import BreadcrumbComponent from "../../components/breadcrumb-component/breadcrumb-component";
import TabsComponent from "../../components/tabs-component/tabs-component";

// Style Imports
import "./cards.styles.scss";
import NotificationCenter from "./components/notification-center/notification-center.component";
import EmailComponent from "./components/email/email.component";
import ActionCardsComponent from "./components/action-cards/action-cards.component";
import { useDispatch } from "react-redux";
import { CREATE_BREADCRUMB } from "src/store/actions";

const Cards: React.FC = (): ReactElement => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState<string>(
    queryParams.get("tab") || "1"
  );

  useEffect(() => {
    dispatch({
      type: CREATE_BREADCRUMB,
      payload: {
        breadcrumb: [
          {
            text: "Cards",
            type: "link",
            link: "/cards",
          },
        ],
      },
    });
  }, []);

  const items: any = [
    {
      key: "1",
      label: `Notification center`,
      children: <NotificationCenter />,
    },
    // {
    //   key: "2",
    //   label: `Email`,
    //   children: <EmailComponent />
    // },
    // {
    //   key: "3",
    //   label: `Action card`,
    //   children: <ActionCardsComponent />
    // }
  ];

  const onTabChange = (activeKey: string): void => {
    setActiveTab(activeKey);
  };

  return (
    <div className="cards-container flex flex-col">
      <div className="flex items-center justify-between flex-wrap">
        <BreadcrumbComponent />
      </div>
      <TabsComponent
        items={items}
        activeTab={activeTab}
        onChange={onTabChange}
      />
    </div>
  );
};

export default Cards;
